/* ============================================
   STORE LOCATOR — store-locator.js
   ============================================ */

(function () {
  'use strict';

  const CSV_URL        = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSRg-K5VgGSoKpEVj5nCYJ5SBnCa0GGDc8BCydiFT7hZDL4Ks3vEd46FzMt9OcDNW8wdKpdCi7kOu6M/pub?output=csv';
  const DEFAULT_CENTER = [46.603354, 1.888334];
  const DEFAULT_ZOOM   = 6;
  const MAX_RESULTS    = 50;
  const GEO_RADIUS_KM  = 100;
  const RADII          = [10, 25, 50, 100];
  const MIN_RESULTS    = 3; // seuil minimum avant d'élargir le rayon

  let map, clusterGroup, userMarker;
  let allStores  = [];
  let activeItem = null;
  let markers    = {};
  let geoActive  = false;
  let searchZoom = null; // zoom au moment de la recherche
  let autocompleteTimer = null;

  const elLoading     = document.getElementById('sl-loading');
  const elEmpty       = document.getElementById('sl-empty');
  const elList        = document.getElementById('sl-list');
  const elCount       = document.getElementById('sl-results-count');
  const elSearchInput = document.getElementById('sl-search-input');
  const elSearchBtn   = document.getElementById('sl-search-btn');
  const elGeoBtn      = document.getElementById('sl-geolocate-btn');
  const elResetBtn    = document.getElementById('sl-reset-btn');

  function init() {
    initMap();
    loadCSV();
    bindEvents();
    createAutocompleteBox();
  }

  function initMap() {
    map = L.map('sl-map', { center: DEFAULT_CENTER, zoom: DEFAULT_ZOOM, zoomControl: true });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributeurs',
    subdomains: 'abc',
    maxZoom: 19
  }).addTo(map);

    // Dézoom rapide : reset dès -3 niveaux par rapport au zoom de recherche
    map.on('zoomend', () => {
      if (geoActive && searchZoom !== null && map.getZoom() <= searchZoom - 1) {
        geoActive = false;
        searchZoom = null;
        if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
        renderList(allStores);
        plotMarkers(allStores);
        elCount.innerHTML = '<strong>' + allStores.length + '</strong> stores au total';
        elGeoBtn.innerHTML = '📍 Autour de moi';
      }
    });

    clusterGroup = L.markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 60,
      spiderfyOnMaxZoom: true,
      disableClusteringAtZoom: 16
    });

    map.addLayer(clusterGroup);
  }

  function loadCSV() {
    showLoading(true);
    fetch(CSV_URL)
      .then(r => { if (!r.ok) throw new Error('Erreur réseau'); return r.text(); })
      .then(text => {
        allStores = parseCSV(text);
        showLoading(false);
        renderList(allStores);
        plotMarkers(allStores);
        elCount.innerHTML = '';
      })
      .catch(err => {
        showLoading(false);
        elEmpty.style.display = 'block';
        elEmpty.textContent = 'Impossible de charger les données. Veuillez réessayer.';
        console.error('Store Locator:', err);
      });
  }

  function parseCSV(text) {
    const lines  = text.split('\n');
    const header = lines[0].split(',').map(h => h.trim().replace(/^"|"$/g, '').toLowerCase());
    const idx = {
      name:    findCol(header, ['store name', 'storename', 'name']),
      address: findCol(header, ['address']),
      region:  findCol(header, ['region']),
      country: findCol(header, ['country']),
      url:     findCol(header, ['url', 'website']),
      mobile:  findCol(header, ['mobile', 'phone', 'tel']),
      email:   findCol(header, ['email']),
      type:    findCol(header, ['type']),
      coords:  findCol(header, ['coordinates', 'coords', 'latlng'])
    };
    const stores = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = splitCSVLine(lines[i]);
      if (!cols || cols.length < 2) continue;
      const coordRaw = get(cols, idx.coords);
      if (!coordRaw) continue;
      const parts = coordRaw.split(',');
      const lat   = parseFloat(parts[0]);
      const lng   = parseFloat(parts[1]);
      if (isNaN(lat) || isNaN(lng)) continue;
      stores.push({
        id: i, name: get(cols, idx.name) || 'Store',
        address: get(cols, idx.address) || '', region: get(cols, idx.region) || '',
        country: get(cols, idx.country) || '', url: get(cols, idx.url) || '',
        mobile: get(cols, idx.mobile) || '', email: get(cols, idx.email) || '',
        type: get(cols, idx.type) || '', lat, lng, distance: null
      });
    }
    return stores;
  }

  function findCol(header, candidates) {
    for (const c of candidates) {
      const i = header.findIndex(h => h.includes(c));
      if (i !== -1) return i;
    }
    return -1;
  }

  function get(cols, idx) {
    if (idx === -1 || idx >= cols.length) return '';
    return cols[idx].trim().replace(/^"|"$/g, '');
  }

  function splitCSVLine(line) {
    const result = [];
    let current  = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') { inQuotes = !inQuotes; }
      else if (ch === ',' && !inQuotes) { result.push(current); current = ''; }
      else { current += ch; }
    }
    result.push(current);
    return result;
  }

  /* ── AUTOCOMPLETE ────────────────────────── */
  function createAutocompleteBox() {
    const box = document.createElement('ul');
    box.id = 'sl-autocomplete';
    elSearchInput.parentNode.style.position = 'relative';
    elSearchInput.parentNode.appendChild(box);
  }

  function getAutocompleteBox() { return document.getElementById('sl-autocomplete'); }

  function showAutocomplete(items) {
    const box = getAutocompleteBox();
    box.innerHTML = '';
    if (!items.length) { box.style.display = 'none'; return; }
    items.forEach(item => {
      const li = document.createElement('li');
      li.className = 'sl-autocomplete-item';
      li.textContent = item.display_name;
      li.addEventListener('mousedown', (e) => {
        e.preventDefault();
        elSearchInput.value = item.display_name;
        box.style.display = 'none';
        executeSearch(parseFloat(item.lat), parseFloat(item.lon));
      });
      box.appendChild(li);
    });
    box.style.display = 'block';
  }

  function hideAutocomplete() {
    const box = getAutocompleteBox();
    if (box) box.style.display = 'none';
  }

  function fetchAutocomplete(query) {
    if (query.length < 3) { hideAutocomplete(); return; }
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5&addressdetails=1`;
    fetch(url, { headers: { 'Accept-Language': 'fr' } })
      .then(r => r.json())
      .then(results => showAutocomplete(results))
      .catch(() => hideAutocomplete());
  }

  /* ── RENDER LIST ─────────────────────────── */
  function renderList(stores) {
    elList.innerHTML = '';
    elEmpty.style.display = 'none';
    if (!stores.length) {
      elEmpty.style.display = 'block';
      elEmpty.textContent   = 'Aucun résultat dans cette zone.';
      elCount.innerHTML     = '<strong>0</strong> résultats trouvés';
      return;
    }
    const shown = stores.slice(0, MAX_RESULTS);
    elCount.innerHTML = '<strong>' + stores.length + '</strong> résultat' + (stores.length > 1 ? 's' : '') + ' trouvé' + (stores.length > 1 ? 's' : '');
    shown.forEach(store => {
      const li = document.createElement('li');
      li.className  = 'sl-store-item';
      li.dataset.id = store.id;
      li.innerHTML  = `
        <div class="sl-store-info">
          <p class="sl-store-name">${escHtml(store.name)}</p>
          <p class="sl-store-address">${escHtml(store.address)}</p>
        </div>
        ${store.distance !== null ? `<span class="sl-store-distance">${store.distance.toFixed(2)} km</span>` : ''}
      `;
      li.addEventListener('click', () => selectStore(store, li));
      elList.appendChild(li);
    });
  }

  /* ── MARKERS ─────────────────────────────── */
  function plotMarkers(stores) {
    clusterGroup.clearLayers();
    markers = {};
    const pinIcon = L.divIcon({
      className: '',
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36">
        <path d="M14 0C6.27 0 0 6.27 0 14c0 9.625 14 22 14 22S28 23.625 28 14C28 6.27 21.73 0 14 0z" fill="#6366f1"/>
        <circle cx="14" cy="14" r="6" fill="#fff"/>
      </svg>`,
      iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -38]
    });
    stores.forEach(store => {
      const marker = L.marker([store.lat, store.lng], { icon: pinIcon });
      marker.bindPopup(buildPopup(store), { className: 'sl-popup', maxWidth: 280 });
      markers[store.id] = marker;
      clusterGroup.addLayer(marker);
    });
  }

  function buildPopup(store) {
    let html = `<div class="sl-popup-inner">
      <p class="sl-popup-name">${escHtml(store.name)}</p>
      <p class="sl-popup-address">${escHtml(store.address)}</p>`;
    if (store.mobile) {
      html += `<div class="sl-popup-links"><a href="tel:${escHtml(store.mobile)}" class="sl-popup-link secondary">${escHtml(store.mobile)}</a></div>`;
    }
    html += `</div>`;
    return html;
  }

  /* ── SELECT STORE ────────────────────────── */
  function selectStore(store, li) {
    if (activeItem) activeItem.classList.remove('active');
    activeItem = li;
    li.classList.add('active');
    map.setView([store.lat, store.lng], 15, { animate: true });
    const marker = markers[store.id];
    if (marker) { clusterGroup.zoomToShowLayer(marker, () => { marker.openPopup(); }); }
  }

  /* ── SEARCH ──────────────────────────────── */
  function doSearch() {
    const query = elSearchInput.value.trim();
    if (!query) return;
    hideAutocomplete();
    fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1`, { headers: { 'Accept-Language': 'fr' } })
      .then(r => r.json())
      .then(results => {
        if (!results.length) { alert('Aucun lieu trouvé pour "' + query + '"'); return; }
        executeSearch(parseFloat(results[0].lat), parseFloat(results[0].lon));
      })
      .catch(() => alert('Erreur de géocodage, veuillez réessayer.'));
  }

  /* ── ZOOM INTELLIGENT ────────────────────── */
  function executeSearch(lat, lng) {
    if (userMarker) map.removeLayer(userMarker);
    userMarker = L.marker([lat, lng], {
      icon: L.divIcon({ className: 'sl-user-pin', iconSize: [16, 16], iconAnchor: [8, 8] })
    }).addTo(map);

    // Élargir le rayon tant qu'on a moins de MIN_RESULTS résultats
    let results = [];
    for (const r of RADII) {
      results = allStores
        .map(s => ({ ...s, distance: haversine(lat, lng, s.lat, s.lng) }))
        .filter(s => s.distance <= r)
        .sort((a, b) => a.distance - b.distance);
      if (results.length >= MIN_RESULTS) break;
    }

    geoActive = true;
    renderList(results);
    plotMarkers(results);

    if (results.length) {
      const group = L.featureGroup(results.map(s => L.marker([s.lat, s.lng])));
      map.fitBounds(group.getBounds().pad(0.2), { animate: true });
      // On mémorise le zoom après fitBounds pour le dézoom
      map.once('moveend', () => { searchZoom = map.getZoom(); });
    } else {
      map.setView([lat, lng], 9);
      searchZoom = 9;
    }
  }

  /* ── GEOLOCATE ───────────────────────────── */
  function geolocate() {
    if (!navigator.geolocation) { alert('La géolocalisation n\'est pas disponible.'); return; }
    elGeoBtn.innerHTML = '<span class="sl-geo-spinner"></span> Localisation...';
    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude: lat, longitude: lng } = pos.coords;
        elGeoBtn.innerHTML = '📍 Autour de moi';
        executeSearch(lat, lng);
      },
      () => { elGeoBtn.innerHTML = '📍 Autour de moi'; alert('Impossible d\'obtenir votre position.'); }
    );
  }

  /* ── RESET ───────────────────────────────── */
  function reset() {
    elSearchInput.value = '';
    hideAutocomplete();
    if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
    if (activeItem)  { activeItem.classList.remove('active'); activeItem = null; }
    geoActive  = false;
    searchZoom = null;
    renderList(allStores);
    plotMarkers(allStores);
    map.setView(DEFAULT_CENTER, DEFAULT_ZOOM);
    elCount.innerHTML = '<strong>' + allStores.length + '</strong> stores au total';
  }

  /* ── EVENTS ──────────────────────────────── */
  function bindEvents() {
    elSearchBtn.addEventListener('click', doSearch);
    elSearchInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') doSearch();
      if (e.key === 'Escape') hideAutocomplete();
    });
    elSearchInput.addEventListener('input', () => {
      clearTimeout(autocompleteTimer);
      autocompleteTimer = setTimeout(() => fetchAutocomplete(elSearchInput.value.trim()), 300);
    });
    elSearchInput.addEventListener('blur', () => setTimeout(hideAutocomplete, 200));
    elGeoBtn.addEventListener('click', geolocate);
    elResetBtn.addEventListener('click', reset);
    document.addEventListener('click', e => {
      if (!e.target.closest('#sl-search-row')) hideAutocomplete();
    });
  }

  /* ── UTILS ───────────────────────────────── */
  function haversine(lat1, lng1, lat2, lng2) {
    const R    = 6371;
    const dLat = rad(lat2 - lat1);
    const dLng = rad(lng2 - lng1);
    const a    = Math.sin(dLat/2) * Math.sin(dLat/2) +
                 Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
                 Math.sin(dLng/2) * Math.sin(dLng/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function rad(deg) { return deg * Math.PI / 180; }

  function escHtml(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function showLoading(show) {
    elLoading.style.display = show ? 'block' : 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();